/* prettier-ignore */
export const DRAW_COLORS = [
  '#ffffff', '#fff403', '#ff7a00', '#fe2700', '#ff2df7', '#376dff', '#21fee9', '#30e951', '#444444', '#262626',
];
